<script>
  import { getContext } from 'svelte';
  // import MdKeyboardArrowUp from 'svelte-icons/md/MdKeyboardArrowUp.svelte';
  import { slide } from 'svelte/transition';
  export let id;
  export let title;
  export let subTitle = '';
  let isHovered = false;
  let isFocused = false;
  const active = getContext('context');
  $: isCurrentActive = $active === id;
  const onClickHandler = () => {
    if (isCurrentActive) {
      $active = null;
    } else {
      $active = id;
    }
  };
</script>

<div
  class="
  wrapper-item
"
>
  <button
    on:click="{onClickHandler}"
    on:mouseenter="{() => (isHovered = true)}"
    on:mouseleave="{() => (isHovered = false)}"
    on:focus="{() => (isFocused = true)}"
    on:blur="{() => (isFocused = false)}"
    class="wrapper-title flex text-left w-full items-center p-4"
  >
    <div class="w-full">
      <div
        class="
          "
        
      >
        <span
          class="
                  title
              "
          class:border-opacity-50="{isFocused}"
          class:border-blue-300="{isFocused}"
        >
          {title}
        </span>
      </div>
      {#if !!subTitle}
        <div class="text-gray-400 text-sm">
          {subTitle}
        </div>
      {/if}
    </div>
    <div
      class="
          w-8
          transform 
          transition
          text-gray-300 
      "
      class:rotate-180="{isCurrentActive}"
      
    >
    <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="m12 15.4l-6-6L7.4 8l4.6 4.6L16.6 8L18 9.4Z"/></svg>
      <!-- <MdKeyboardArrowUp /> -->
    </div>
  </button>
  {#if isCurrentActive}
    <div class="text px-4 pb-4 mt-4" transition:slide>
      <slot />
    </div>
  {/if}
</div>

<style>
  .arrow {
    width: 30px;
    height: 30px;
    transform-origin: center;
    /* transform: rotate(180deg); */
    transition: transform 600ms;
  }
  .arrow path {
    fill:#000;
  }
  .wrapper-item {
    padding:15px 0 0;
  }
  .wrapper-title {
    margin-bottom: 16px;
    outline: 2px solid #000;
    transition: all .4s;
    width: 100%;
  }
  .wrapper-title:hover {
    outline: 5px solid #000;
  }
  .title {
    font-family: intro;
font-size: 18px;
  }
  .text {
    font-family: introlight;
font-size: 18px;
  }

</style>